import React, { useEffect } from 'react';

/* ASA-1238 - DE ENE PLEK DIE DE BESTEMMING NA INLOGGEN KENT.
 *
 * WAAROM DIT GEEN REACT-ROUTER-NAVIGATIE IS, en dat is de kern van dit bestand.
 * `/slimme-assistent/` is GEEN route van deze applicatie. De edge routeert dat pad naar een eigen
 * container (ventus/edge/nginx.conf); het portaal zit op `/`. Een <Navigate to="/slimme-assistent/">
 * zou dus binnen deze router blijven, geen route matchen, op de `*`-route vallen en daar opnieuw
 * doorverwijzen - een oneindige lus, en wel een stille: de gebruiker ziet een leeg scherm.
 * Vandaar een ECHTE paginalading, met dezelfde vorm als de bestaande link in components/Layout.js
 * (absolute origin, ASA-258/ASA-686).
 *
 * `replace` en niet `href`: na inloggen hoort de terugknop je niet terug naar het inlogformulier te
 * brengen.
 *
 * DE LUSBEVEILIGING IS NIET THEORETISCH, en daarom staat hij in code en niet in een commentaarregel.
 * Bedient de edge `/slimme-assistent/` NIET - een lokale ontwikkelomgeving, een verkeerd uitgerolde
 * nginx, of de container die stilligt - dan komt dat pad bij DEZE applicatie terecht, matcht het de
 * `*`-route, en zou het opnieuw doorverwijzen. Elke ronde is dan een volledig netwerkverzoek. Daarom
 * verwijst dit component NIET door zodra we al op dat pad staan, maar toont het een melding met een
 * weg terug. Fail-loud in plaats van fail-silent.
 */
export const BESTEMMING = '/slimme-assistent/';

export default function NaarSlimmeAssistent() {
  /* HET PREDICAAT IS DE VERZAMELING DIE DE EDGE NAAR DE VSA ROUTEERT, en niets ruimer.
   *
   * Hier stond `startsWith('/slimme-assistent')` -- zonder afsluitende slash -- en dat is TE BREED.
   * GEMETEN OP PRODUCTIE (01-10-2026, via-ventus.nl):
   *   /slimme-assistent/     -> 200, titel "Ventus Slimme Assistent"  (de VSA-container)
   *   /slimme-assistentie    -> 200, titel "Ventus"                   (het PORTAAL)
   *   /slimme-assistent-oud  -> 200, titel "Ventus"                   (het PORTAAL)
   *
   * Op die laatste twee vuurt de *-route van deze router, werd alDaar true, en kreeg de gebruiker
   * een melding dat de Slimme Assistent niet bereikbaar is -- terwijl hij gewoon werkt. Dat schendt
   * AC-4, dat juist een doorverwijzing eist, en de melding is feitelijk onjuist.
   *
   * De verzameling is AFGELEID uit BESTEMMING en niet een tweede keer opgeschreven: het pad zonder
   * slash (de edge stuurt daar een 301 naar de slash-variant) en alles eronder. */
  const pad = window.location.pathname;
  const alDaar = pad === BESTEMMING.replace(/\/$/, "") || pad.startsWith(BESTEMMING);

  useEffect(() => {
    if (alDaar) return;
    window.location.replace(window.location.origin + BESTEMMING);
  }, [alDaar]);

  if (alDaar) {
    return (
      <div className="v-loading" role="alert">
        De Slimme Assistent is op dit moment niet bereikbaar op dit adres. Ga naar{' '}
        <a href={window.location.origin + '/workspaces'}>de kennisbank</a> om verder te werken.
      </div>
    );
  }
  return <div className="v-loading">Een moment, we brengen je naar de Slimme Assistent...</div>;
}
